module.exports = __webpack_public_path__ + "img/bg-s02.3ca41d99.jpg";